import React,{Component} from 'react'
// import SideNav from '../SideNav';
import {Link,Redirect} from 'react-router-dom';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import auth from '../Auth';
import '../../App.css'

class Navbar extends Component {
    state={
        isRedirect:false,
        username:'Akshay'
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.location !== prevProps.location) {
            var elems = document.querySelectorAll('.dropdown-trigger');
            M.Dropdown.init(elems, {});
            this.setUser()
        }
    }

    constructor(props){
        super(props)
        var elems = document.querySelectorAll('.dropdown-trigger');
        M.Dropdown.init(elems, {});
        // this.setUser()
    }
    componentDidMount(){
        var elems = document.querySelectorAll('.dropdown-trigger');
         M.Dropdown.init(elems,{});
         this.setUser()
    }

    setUser(){
        if(auth.isValid){
           let data = JSON.parse(localStorage.getItem('userDetails'))
        //    console.log(data)
            this.setState({
                username:data.firstName
            })
        }
    }
    
    
render(){
    let {heading} = this.props;
    return(
        <header className="wrapper">
        <div className="container">
        {this.state.isRedirect?<Redirect to="/"/>:null}
        <div className="navbar-fixed">
        <ul  id="dropdown1" className="dropdown-content">
            <li className="divider"></li>
            <li><span onClick={()=>{auth.logout(()=> {this.setState({isRedirect:true})})}} >Logout </span></li>
        </ul>
            <nav className="blue-grey">
           
              <a href="#!" className="brand-logo margin-onoff">{heading}</a>
                <ul className="right hide-on-med-and-down" style={{marginRight: 40}}>
                {/* <li><Link to="#"><i className="material-icons">notifications</i> </Link></li> */}
                <li><span className="dropdown-trigger waves-effect waves-light" href="#!" data-target="dropdown1">Welcome : {this.state.username}<i className="material-icons right">arrow_drop_down</i></span></li>
                </ul>
       
            <Link to="#"  data-target="slide-out" className="sidenav-trigger hide-on-large-only"><i className="material-icons">menu</i></Link>
         
            </nav>
            </div>
        </div>
    </header>
    );
}
}
export default Navbar;
